import { PhosphorIconForExportOption } from "components/Atoms/PhosphorIcon";
import React from "react";

interface Props {
  exportOption: server.dto.ExportOption
}

const DocumentFromTemplateRowCard = (props: Props) => {
  const { exportOption } = props;

  const [
    firstExportOption, // DOCX for internal users, PDF for external users
    secondExportOption, // PDF for internal users, null for external users
    savePdfToOnlineStorage // "Save pdf to files" for internal users, null for external users
  ] = exportOption.exportTypes;

  const onSavePdfToOnlineStorage = () => {
    window.onSavePdfToOnlineStorage(
      savePdfToOnlineStorage.links[0].url,
      savePdfToOnlineStorage.links[0].fileName,
      exportOption.preferredCulture.value
    );
  };

  return <div className="s1-exportpanel-row">
    <div>
      <span className={exportOption.flagClass} />
    </div>
    <div className="grow1 flex-column gap">
      <div>
        <h4>
          {exportOption.title}
        </h4>
      </div>
      <div className="flex gap-large">
        <div className="flex gap-small">
          <PhosphorIconForExportOption type={firstExportOption} />
          <a download href={firstExportOption.links[0].url}>
            {firstExportOption.links[0].label}
          </a>
        </div>

        {secondExportOption && <div className="flex gap-small">
          <PhosphorIconForExportOption type={secondExportOption} />
          <a download href={secondExportOption.links[0].url}>
            {secondExportOption.links[0].label}
          </a>
        </div>}

        {savePdfToOnlineStorage && <div className="flex gap-small">
          <PhosphorIconForExportOption type={savePdfToOnlineStorage} />
          <a onClick={onSavePdfToOnlineStorage}>
            {savePdfToOnlineStorage.links[0].label}
          </a>
        </div>}
      </div>
    </div>
  </div>;
};

export default DocumentFromTemplateRowCard;